/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1OrganizationEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_ORGANIZATION_EVENT_ENTITY_NAME = 'ixm.userauth.v1.OrganizationEvent';
export const ixmUserauthV1OrganizationEventEntity = new schema.Entity<IxmUserauthV1OrganizationEvent>(IXM_USERAUTH_V1_ORGANIZATION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmUserauthV1OrganizationEvent) => `${entity.metadata?.eventId}` });

